// @flow
export { default } from './OrderListTemplate';



// WEBPACK FOOTER //
// ./src/components/order/OrderListTemplate/index.js